import { render, staticRenderFns } from "./InvoiceArTax.vue?vue&type=template&id=b63f78ae&"
import script from "./InvoiceArTax.vue?vue&type=script&lang=ts&"
export * from "./InvoiceArTax.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b63f78ae')) {
      api.createRecord('b63f78ae', component.options)
    } else {
      api.reload('b63f78ae', component.options)
    }
    module.hot.accept("./InvoiceArTax.vue?vue&type=template&id=b63f78ae&", function () {
      api.rerender('b63f78ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/account-receivables/invoice-ar/InvoiceArTax.vue"
export default component.exports